import { Header } from "../../components/Elements/Header";
import { useAuth } from "../../providers/auth";
import UserForm from "../../components/Forms/UserForm";
import Footer from "../../components/Elements/Footer";

const UserPage = () => {
  const { token } = useAuth();

  return (
    <>
      <Header />
      <div id="wrapper" className="p-0">
        <main className="page-header form-page flex-fill justify-content-start">
          <div className="container position-relative py-5">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-xl-7">
                <h1 className="text-center form-page-title mb-2">
                  {!!token ? "Meus Dados" : "Crie sua conta"}
                </h1>
                <p className="text-center text-muted mb-4">
                  {!!token
                    ? "Atualize seus dados de acesso, contato e endereço."
                    : "Leva menos de 2 minutos — e você já sai pronto para agendar sua consulta."}
                </p>
                <UserForm />
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default UserPage;
